/*
 * ttg-exit-banner.js — Exit-Intent-Banner auf Konfigurator-Produktseiten.
 * ---------------------------------------------------------------------------
 * Laedt nur, wenn snippets/ttg-exit-banner.liquid Markup gerendert hat, also
 * nur wenn das Metaobjekt ttg_exit_banner/standard existiert UND aktiv ist.
 *
 * Dieses Skript enthaelt KEINE Inhalte: Titel, Nachrichten, Fusszeile, Produkte,
 * Preise, Bilder und URLs stehen vollstaendig im server-gerenderten Markup. Hier
 * liegt ausschliesslich das Verhalten (Ausloeser, Anzeigen, Schliessen).
 *
 * ABGRENZUNG zu ttg-crosssell.js: Dort gibt es ein aelteres Exit-Intent-Popup
 * (mode 'pdp'), das seit 19.07.2026 per EXIT_INTENT_ENABLED = false hart AUS
 * ist. Beide gleichzeitig sichtbar waeren ein Unfall (zwei Dialoge, zwei
 * Scroll-Sperren). Deshalb unten der Kollisionsschutz gegen ein offenes
 * .ttg-xsell-overlay — er kostet nichts und traegt, falls der alte Schalter je
 * wieder auf true geht.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ttg-exit-root]');
  if (!root) return;

  var host = document.querySelector('ttg-customizer');
  var SESSION_KEY = 'ttg_exit_banner_shown';
  var MAX_KACHELN = 5;
  var DEFAULT_INAKTIV_MS = 60000;

  var stil = root.dataset.stil || 'nachrichten';
  var zurueckAbfangen = root.dataset.zurueck === '1';
  /* Strikt auf '1' pruefen, nie auf Wahrheitswert des Strings: "false" waere
     wahr. Das Liquid loest den Schalter schon zu 1/0 auf, hier die zweite
     Sperre. Fehlt das Attribut, ist der Trigger AUS. */
  var navAbfangen = root.dataset.navigation === '1';
  /* Touch-Geraet? Entscheidet, ob die mobilen Ausloeser (Inaktivitaet,
     Zurueck-Abfangen) ueberhaupt armiert werden. Der Desktop-Ausloeser
     (mouseout) haengt immer — auf Touch feuert er von sich aus nicht. */
  var istTouch = !!(window.matchMedia
    && window.matchMedia('(hover: none), (pointer: coarse)').matches);
  var inaktivMs = parseInt(root.dataset.inaktivMs, 10);
  if (!(inaktivMs > 0)) inaktivMs = DEFAULT_INAKTIV_MS;   // leeres/kaputtes Feld → Default
  var aktuellesProdukt = root.dataset.produktId || '';

  var engagiert = false;      // (a) Kunde hat den Konfigurator angefasst
  var imWarenkorb = false;    // (b) Add-to-Cart auf dieser Seite
  var gezeigt = false;
  var offen = false;
  var letzterFokus = null;
  var vorherOverflow = '';
  var inaktivTimer = null;
  var dummyGesetzt = false;   // History-Eintrag fuers Zurueck-Abfangen
  var dummyVerbraucht = false;
  /* Ziel eines abgefangenen Navigationsklicks. Solange hier etwas steht, schuldet
     das Banner dem Kunden diese Navigation — beim Schliessen wird sie ausgefuehrt.
     Der Klick darf NIE verloren gehen. */
  var zielUrl = null;
  /* Wurde in DIESER Oeffnung eine Produktkachel geklickt? Entscheidet, ob ein
     spaeteres Schliessen als "geschlossen ohne Klick" zaehlt. */
  var kachelGeklickt = false;

  /* ────────────────────────────────────────────────── Messung
   *
   * VIER EREIGNISSE, mehr nicht: angezeigt · kachel · geschlossen · rabatt.
   * ("rabatt" ist vorgesehen, aber es gibt keinen Rabatt-Knopf — Teil 5 ist
   * nicht gebaut. Der Name steht hier, damit die Gegenseite ihn kennt, nicht
   * damit hier etwas gesendet wuerde.)
   *
   * ═══ EIN FEHLSCHLAG DARF DAS BANNER NIE BEEINTRAECHTIGEN ═══
   * Alles laeuft in try/catch, nichts wird abgewartet, kein Rueckgabewert wird
   * gelesen. Ist der Endpunkt tot, langsam oder liefert 500, merkt der Kunde
   * davon nichts — das Banner kennt den Ausgang gar nicht.
   *
   * ═══ KEIN await ═══
   * Der Kachel-Klick navigiert weg. Ein normales fetch() wuerde beim Entladen
   * der Seite abgebrochen, und die Zaehlung fiele ausgerechnet fuer das
   * wichtigste Ereignis aus. sendBeacon uebergibt den Aufruf dem Browser, der
   * ihn ueber das Entladen hinaus zu Ende bringt — und kehrt SOFORT zurueck,
   * verzoegert die Navigation also nicht. Der Fallback fetch(keepalive:true)
   * hat dieselbe Eigenschaft fuer Browser ohne sendBeacon.
   *
   * ═══ WAS GESENDET WIRD ═══
   * Genau vier Felder. Keine IP (die sieht nur der Server und verwirft sie),
   * keine Kunden-ID, keine Sitzungskennung. Was hier nicht drinsteht, kann
   * auch nicht gespeichert werden.
   */
  var MESS_URL = root.dataset.messUrl || '';
  /* mobil/desktop aus matchMedia, NICHT aus dem User-Agent — der luegt, und zwar
     seit Jahren absichtlich. Bewusst dieselbe Abfrage wie `istTouch` oben statt
     einer zweiten, konkurrierenden Vorstellung von "mobil": Zwei Definitionen in
     einer Datei laufen irgendwann auseinander, und dann widersprechen sich
     Ausloeser und Statistik. Tablets zaehlen damit als "mobil". */
  var GERAET = istTouch ? 'mobil' : 'desktop';
  /* Kurzform der Seite (nur der Handle), rein informativ — der Server speichert
     sie nicht, der Schluessel ist datum+ereignis+produkt+geraet. */
  var SEITE = (location.pathname.split('/').pop() || '').slice(0, 80);

  function melde(ereignis, produkt) {
    if (!MESS_URL) return;
    try {
      var last = JSON.stringify({
        ereignis: ereignis,
        produkt: produkt || '',
        seite: SEITE,
        geraet: GERAET
      });
      /* text/plain ist ein CORS-sicherer Inhaltstyp: kein OPTIONS-Vorabflug,
         also auch keine zweite Anfrage, die beim Entladen scheitern koennte. */
      if (navigator.sendBeacon) {
        var blob = new Blob([last], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(MESS_URL, blob)) return;
        /* sendBeacon meldet false, wenn die Warteschlange voll ist — dann
           weiter zum Fallback statt still nichts zu tun. */
      }
      if (window.fetch) {
        fetch(MESS_URL, {
          method: 'POST',
          body: last,
          keepalive: true,
          mode: 'cors',
          credentials: 'omit',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' }
        }).catch(function () { /* Ausgang geht das Banner nichts an */ });
      }
    } catch (e) { /* Messung ist nie wichtiger als das Banner */ }
  }

  /* ────────────────────────────────────────────────── Produktauswahl
   * EINZIGER Ort, an dem entschieden wird, welche Kacheln das Banner zeigt.
   *
   * Heute: feste Reihenfolge aus dem Metaobjekt, minus Selbstausschluss,
   * aufgefuellt bis MAX_KACHELN. Liegen im Metaobjekt mehr Produkte als
   * Kacheln, ruecken die naechsten nach — es bleiben also 5, solange genug
   * hinterlegt sind.
   *
   * ERWEITERUNGSPUNKT (bewusst noch nicht gebaut): Hier kann spaeter eine
   * Auswahl nach Konfigurator-Familie stehen — etwa "zur Weste zuerst die
   * passenden Westen-Editionen, dann der Rest". Dafuer ist nichts weiter noetig,
   * als diese eine Funktion zu ersetzen; Aufrufer, Markup und Tracking bleiben
   * unveraendert. Deshalb bekommt sie schon jetzt beide Eingaben, auch wenn die
   * heutige Regel das aktuelle Produkt nur zum Ausschliessen braucht.
   *
   * @param {HTMLElement[]} alleProdukte  alle gerenderten Kacheln, in Metaobjekt-Reihenfolge
   * @param {string} aktuellesProdukt     product.id der Seite, auf der der Kunde steht
   * @returns {HTMLElement[]}             die anzuzeigenden Kacheln
   */
  function pickProducts(alleProdukte, aktuellesProdukt) {
    var behalten = [];
    for (var i = 0; i < alleProdukte.length; i++) {
      if (alleProdukte[i].dataset.produktId === String(aktuellesProdukt)) continue;  // Selbstausschluss
      behalten.push(alleProdukte[i]);
      if (behalten.length >= MAX_KACHELN) break;
    }
    return behalten;
  }

  /* Auswahl EINMAL beim Start anwenden: ueberzaehlige Kacheln raus, bevor das
     Banner je sichtbar wird. Weil die Bilder `loading="lazy"` tragen und das
     Banner `hidden` ist, wurde bis hier kein einziges Bild geladen — die
     entfernten Kacheln kosten also auch keinen Download. */
  var kachelWrap = root.querySelector('[data-ttg-exit-kacheln]');
  if (kachelWrap) {
    var alle = Array.prototype.slice.call(kachelWrap.querySelectorAll('[data-ttg-exit="produkt"]'));
    var behalten = pickProducts(alle, aktuellesProdukt);
    for (var i = 0; i < alle.length; i++) {
      if (behalten.indexOf(alle[i]) === -1) alle[i].remove();
    }
    if (!behalten.length) {
      var block = root.querySelector('.ttg-exit__produkte');
      if (block) block.remove();       // keine Fremdprodukte → keine leere Leiste
    }
    /* Spaltenzahl dem tatsaechlichen Bestand melden. Ohne das stuenden auf dem
       Desktop immer 5 Spalten, und bei 4 Kacheln bliebe rechts eine leere
       Spalte stehen (am 08.08. am Dev-Theme gemessen: 172 px). Weil alle
       hinterlegten Produkte selbst Konfigurator-Produkte sind, greift der
       Selbstausschluss praktisch immer — 4 ist damit der Regelfall, nicht die
       Ausnahme. */
    kachelWrap.style.setProperty('--ttg-exit-n', String(behalten.length));
  }

  /* Ticker: Dauer aus der Spurbreite ableiten, damit die Geschwindigkeit
     unabhaengig von der Anzahl der Nachrichten gleich bleibt (zwei Nachrichten
     wuerden bei fester Dauer sonst vorbeirasen). ~70 px/s. */
  if (stil === 'ticker') {
    var spur = root.querySelector('.ttg-exit__spur');
    if (spur) {
      requestAnimationFrame(function () {
        var breite = spur.scrollWidth / 2;   // halbe Spur = ein voller Satz
        if (breite > 0) spur.style.setProperty('--ttg-exit-ticker-dauer', Math.max(12, Math.round(breite / 70)) + 's');
      });
    }
  }

  /* ────────────────────────────────────────────────── Vorbedingungen */
  function sessionGesperrt() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; }
    catch (e) { return false; }   // Speicher gesperrt → der In-Memory-Guard traegt
  }

  function darfZeigen() {
    if (gezeigt || offen) return false;
    if (!engagiert) return false;                                   // (a)
    if (imWarenkorb) return false;                                  // (b)
    if (sessionGesperrt()) return false;                            // (c)
    if (document.querySelector('.ttg-xsell-overlay.open')) return false;  // Kollisionsschutz
    return true;
  }

  /* ────────────────────────────────────────────────── Anzeigen/Schliessen */
  function fokussierbare() {
    return Array.prototype.slice.call(root.querySelectorAll(
      'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function onKeydown(e) {
    if (!offen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); schliessen(); return; }
    if (e.key !== 'Tab') return;
    // Fokusfalle: Tab darf den Dialog nicht verlassen.
    var f = fokussierbare();
    if (!f.length) { e.preventDefault(); return; }
    var erste = f[0], letzte = f[f.length - 1];
    if (e.shiftKey && document.activeElement === erste) { e.preventDefault(); letzte.focus(); }
    else if (!e.shiftKey && document.activeElement === letzte) { e.preventDefault(); erste.focus(); }
  }

  function zeigen() {
    if (!darfZeigen()) return;
    gezeigt = true;
    offen = true;
    /* Sofort sperren, nicht erst beim Schliessen: bricht der Kunde die Seite
       mitten im Banner ab, ist der Schuss trotzdem verbraucht. */
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* egal */ }

    letzterFokus = document.activeElement;
    root.hidden = false;
    // Erzwingt einen Frame, damit die Einblend-Transition wirklich laeuft.
    void root.offsetWidth;
    root.classList.add('ttg-exit--offen');

    vorherOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';

    var close = root.querySelector('[data-ttg-exit="close"]');
    if (close) { try { close.focus(); } catch (e) { /* egal */ } }
    document.addEventListener('keydown', onKeydown, true);
    stopInaktivTimer();

    /* SICHTBAR, nicht "Skript geladen": Diese Zeile steht hinter darfZeigen()
       und hinter dem Setzen der Offen-Klasse. Ein Banner, das wegen der
       Sitzungssperre oder eines Kollisionsschutzes gar nicht erscheint, zaehlt
       hier nicht mit — sonst waere die Klickrate systematisch zu niedrig. */
    kachelGeklickt = false;
    melde('angezeigt', '');
  }

  function schliessen() {
    if (!offen) return;
    offen = false;

    /* "Geschlossen OHNE Klick" — ein Kachel-Klick navigiert weg und ist damit
       kein Abbruch, sondern ein Erfolg. Ohne diese Abfrage stuende dieselbe
       Sitzung in beiden Zahlen und die Abbruchquote waere frei erfunden.
       (Der Fall ist heute selten: ein Kachel-Klick verlaesst die Seite. Er
       traegt aber, sobald eine Kachel je in einem neuen Tab oeffnet.) */
    if (!kachelGeklickt) melde('geschlossen', '');
    root.classList.remove('ttg-exit--offen');
    document.removeEventListener('keydown', onKeydown, true);
    document.documentElement.style.overflow = vorherOverflow;

    var fertig = function () { root.hidden = true; };
    // Ausblenden abwarten, aber nie daran haengen bleiben.
    setTimeout(fertig, 220);

    if (letzterFokus && letzterFokus.focus) {
      try { letzterFokus.focus(); } catch (e) { /* egal */ }
    }

    /* Eingeloeste Schuld: Wurde das Banner durch einen abgefangenen Klick
       geoeffnet, geht es jetzt dorthin, wo der Kunde hinwollte. Das steht VOR
       der History-Bereinigung — wir verlassen die Seite ohnehin, ein
       history.back() waere hier nicht nur unnoetig, sondern wuerde mit der
       Navigation um dieselbe History konkurrieren. */
    if (zielUrl) {
      var u = zielUrl;
      zielUrl = null;
      try { location.href = u; } catch (e) { /* egal */ }
      return;
    }

    /* History sauber aufraeumen: Wurde ein Dummy-Eintrag fuers Zurueck-Abfangen
       gesetzt und NICHT verbraucht (der Kunde hat das Banner ueber X/Backdrop/Esc
       geschlossen statt ueber die Zurueck-Taste), muss er wieder weg. Sonst
       laendet der naechste Zurueck-Druck stumm auf derselben Seite. Der
       ausgeloeste popstate ist harmlos — der Handler sieht `gezeigt` und tut
       nichts. */
    if (dummyGesetzt && !dummyVerbraucht) {
      dummyVerbraucht = true;
      try { history.back(); } catch (e) { /* egal */ }
    }
  }

  root.addEventListener('click', function (e) {
    var ziel = e.target.closest ? e.target.closest('[data-ttg-exit]') : null;
    if (!ziel) return;
    var art = ziel.getAttribute('data-ttg-exit');
    if (art === 'close' || art === 'backdrop') { e.preventDefault(); schliessen(); }
    /* art === 'produkt' laeuft bewusst durch: der Link soll navigieren. Die
       data-Attribute (data-ttg-exit, data-ttg-exit-handle) stehen fuer eine
       spaetere Auswertung im Markup — hier wird nichts gemessen und nichts
       an Dritte gesendet.
       Die Kachel schlaegt aber ein abgefangenes Navigationsziel: der Kunde hat
       sich sichtbar umentschieden. Ohne dieses Verwerfen wuerde ein spaeteres
       Schliessen ihn noch zum alten Ziel schicken. */
    if (art === 'produkt') {
      zielUrl = null;
      /* VOR der Navigation melden. sendBeacon kehrt sofort zurueck und uebergibt
         den Aufruf dem Browser — der Link folgt unverzoegert, und die Zaehlung
         ueberlebt das Entladen der Seite. Kein preventDefault, kein await:
         Beides wuerde genau den Klick verzoegern, um den es geht. */
      kachelGeklickt = true;
      melde('kachel', ziel.getAttribute('data-ttg-exit-handle') || '');
    }
  });

  /* ────────────────────────────────────────────────── Engagement + Warenkorb */
  function engagieren() {
    if (engagiert) return;
    engagiert = true;
    starteInaktivTimer();
    /* Zurueck-Abfangen erst ab echtem Engagement armieren — vorher waere der
       zusaetzliche History-Eintrag reine Belaestigung. */
    if (zurueckAbfangen && istTouch && !dummyGesetzt) {
      try { history.pushState({ ttgExit: 1 }, '', location.href); dummyGesetzt = true; }
      catch (e) { /* egal */ }
    }
  }

  /* Engine-Ereignisse sind die genaue Quelle: motifChanged/colorChanged/
     optionChanged/sideChanged/variantChanged entstehen ausschliesslich im
     Klick-Handler der Engine (_onAction) — Deep-Link und Late-Default emittieren
     nichts. Damit zaehlt keine Vorbelegung als Kundeninteraktion. */
  function bindeEngine(engine) {
    ['motifChanged', 'colorChanged', 'variantChanged', 'optionChanged', 'sideChanged']
      .forEach(function (evt) { engine.on(evt, engagieren); });
    engine.on('cartAdded', function () { imWarenkorb = true; });
  }

  if (host) {
    /* Sofort binden, wenn die Engine schon steht — erst danach pollen. Sonst
       laege zwischen Skriptstart und erstem Poll-Tick ein Fenster von 250 ms,
       in dem cartAdded verloren ginge (dafuer gibt es, anders als fuer Motiv-
       und Farbklicks, keinen DOM-Rueckfall). */
    if (host.engine) {
      bindeEngine(host.engine);
    } else {
      var versuche = 0;
      var poll = setInterval(function () {
        versuche += 1;
        if (host.engine) { clearInterval(poll); bindeEngine(host.engine); return; }
        if (versuche > 240) clearInterval(poll);   // 60 s; mountet die Engine nicht, traegt der DOM-Weg unten
      }, 250);
    }
  }

  /* Tippen: bewusst NICHT ueber das Engine-Ereignis textChanged. Das feuert auch
     beim Setzen/Entfernen des "Kein Text"-Hakens und traegt dann einen Wert, der
     nie getippt wurde. Ein echtes `input` am Textfeld ist eindeutig. */
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !host || !host.contains(t)) return;
    if (t.matches && t.matches('input[type="text"], textarea')) engagieren();
  }, true);

  /* DOM-Rueckfall, falls die Engine erst nach dem Poll-Fenster mountet: ein Klick
     auf eine Motiv-/Farb-/Groessen-Kachel ist ebenso eindeutig. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !host || !host.contains(t)) return;
    if (t.closest('[data-action="motif"], [data-action="color"], [data-action="size"], [data-action="motif-variant"], [data-action="vo"]')) {
      engagieren();
    }
  }, true);

  /* ────────────────────────────────────────────────── Ausloeser */

  // Desktop: Maus verlaesst das Fenster nach oben.
  document.addEventListener('mouseout', function (e) {
    if (e.clientY > 0) return;
    if (e.relatedTarget) return;
    zeigen();
  });

  // Mobil/Touch (a): Inaktivitaet nach der letzten Interaktion.
  function starteInaktivTimer() {
    if (!istTouch) return;
    stopInaktivTimer();
    inaktivTimer = setTimeout(zeigen, inaktivMs);
  }
  function stopInaktivTimer() {
    if (inaktivTimer) { clearTimeout(inaktivTimer); inaktivTimer = null; }
  }
  ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      if (!engagiert || offen || gezeigt) return;
      starteInaktivTimer();   // jede Interaktion setzt die Uhr zurueck
    }, { passive: true, capture: true });
  });

  /* ────────────────────────────────── Navigations-Trigger (Desktop UND Touch)
   * Klick auf Logo, Menue oder irgendeinen Link weg vom Konfigurator zeigt das
   * Banner einmalig — und fuehrt die Navigation danach selbst aus. Auf dem Handy
   * ist das der erste Ausloeser, der nicht auf Warten beruht.
   *
   * EIN Listener am Dokument in der Capture-Phase plus closest('a[href]'):
   * Das Theme baut Menues zur Laufzeit nach (Drawer, Mega-Menue), einzelne
   * Listener je Link waeren nach jedem Nachbau tot. Kein MutationObserver noetig.
   *
   * Die Ausnahmenliste unten ist der eigentliche Kern. Jeder Fall, der faelschlich
   * abgefangen wird, kostet den Kunden seinen Klick — deshalb im Zweifel NICHT
   * abfangen.
   */
  function istAusnahme(e, a) {
    // Ein anderer Handler hat den Klick schon behandelt (Theme-Drawer o. Ae.).
    if (e.defaultPrevented) return true;
    // Nur der einfache Linksklick. Mittelklick und Modifier oeffnen neue Tabs/
    // Fenster oder laden herunter — da darf sich nichts dazwischenschieben.
    if (typeof e.button === 'number' && e.button !== 0) return true;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return true;
    // Neues Ziel oder ausdruecklich extern → die Seite bleibt ohnehin stehen.
    var target = (a.getAttribute('target') || '').trim();
    if (target && target !== '_self') return true;
    if ((a.getAttribute('rel') || '').toLowerCase().split(/\s+/).indexOf('external') !== -1) return true;
    if (a.hasAttribute('download')) return true;

    var href = (a.getAttribute('href') || '').trim();
    if (!href) return true;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return true;
    if (href.charAt(0) === '#') return true;              // Anker auf dieser Seite

    // Links im Konfigurator selbst und im Banner selbst nie abfangen.
    if (host && host.contains(a)) return true;
    if (root.contains(a)) return true;

    var url;
    try { url = new URL(a.href, location.href); } catch (e2) { return true; }
    // Warenkorb und Kasse sind Kaufabsicht — da stellt sich das Banner NIE in den Weg.
    if (/^\/(cart|checkout)(\/|$)/.test(url.pathname)) return true;
    // Dieselbe Seite (auch als Voll-URL oder mit #anker) ist keine Navigation weg.
    var hier = location.origin + location.pathname + location.search;
    if (url.origin + url.pathname + url.search === hier) return true;
    return false;
  }

  document.addEventListener('click', function (e) {
    if (!navAbfangen) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (istAusnahme(e, a)) return;
    /* Vorbedingungen zuerst pruefen und bei Nichterfuellung NICHTS tun — kein
       preventDefault, keine Verzoegerung. Wer den Konfigurator nicht angefasst
       hat, navigiert voellig unbehelligt. */
    if (!darfZeigen()) return;
    e.preventDefault();
    zielUrl = a.href;
    zeigen();
    /* Fiel das Zeigen wider Erwarten aus (Kollisionsschutz), waere der Klick sonst
       verschluckt: dann sofort selbst navigieren. Der Kunde verliert nie einen
       Klick — das ist wichtiger als das Banner. */
    if (!offen && zielUrl) {
      var u = zielUrl; zielUrl = null;
      try { location.href = u; } catch (e2) { /* egal */ }
    }
  }, true);

  // Mobil/Touch (b): Zurueck-Taste abfangen — nur wenn im Metaobjekt erlaubt.
  window.addEventListener('popstate', function () {
    if (!zurueckAbfangen || !istTouch) return;
    if (!dummyGesetzt || dummyVerbraucht) return;
    dummyVerbraucht = true;
    zeigen();
  });
})();
